<template>
    <div id="visitorMailList">
        <NewMailInterface
            mode="folder-only"
            defaultMode="normal"
            :default-selected-folder="selectedFolder"
            :default-selected-email-id="selectedEmailId"
            :visitor-email-address="visitorMail"
            :ref-visitor-id="visitorId"
            :enabled-select-sender="true"
            @folder-selected="changeFolder"
        />
    </div>
</template>

<script>
import { log2 } from "../../../utils/log2";
import { mapGetters, mapState } from "vuex";
import NewMailInterface from "../Mail/new/NewMailInterface.vue";

const log = log2("VisitorMailList");

export default {
    name: "VisitorMailList",
    components: {
        NewMailInterface,
    },
    props: {
        visitorId: {
            type: String,
        },
        visitorMail: {
            type: String,
        },
        isGetChat: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            selectedFolder: "inbox",
        };
    },
    computed: {
        ...mapGetters({
            allowedMailAddresses: "mail/allowedMailAddresses",
        }),
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            emailSendSuccess: (state) => state.mail.emailSendSuccess,
        }),
        selectedEmailId() {
            const allowedMailAddresses = this.allowedMailAddresses;
            const defaultUserEmail = allowedMailAddresses.find((mail) => {
                return mail.mail === this.user.email && mail.isDefault;
            });
            return defaultUserEmail ? defaultUserEmail._id : allowedMailAddresses[0]._id;
        },
    },
    methods: {
        changeFolder(folder) {
            this.selectedFolder = folder;
        },
    },
    mounted() {},
    watch: {
        emailSendSuccess(val) {
            this.$message.destroy();
            this.$message.success(this.$t("visitor.sendMailSucs"), 3);
        },
    },
};
</script>

<style lang="scss">
#visitorMailList {
    width: 100%;
    overflow: auto;
}
</style>
